/**
 * Onboarding v2 frontend constants
 * Non-CMS-driven defaults and feature flags.
 */

// CMS key for the "Finish with a human" link. The actual URL is seeded
// by Backend and editable via the admin CMS UI. This constant only
// holds the KEY NAME, not the URL.
export const FINISH_WITH_HUMAN_CMS_KEY = 'onboarding_finish_with_human_href';

// Fallback URL if the CMS key has not loaded yet (loading state) or
// hasn't been seeded yet (pre-Phase-v2-1-backend state).
export const FINISH_WITH_HUMAN_HREF_FALLBACK = process.env.REACT_APP_CALENDLY_ONBOARDING_URL;

// Three section labels for the step progress indicator (D2 sections).
export const STEP_SECTIONS = {
  basics:    'THE BASICS',
  guidebook: 'GUIDEBOOK',
  messaging: 'MESSAGING',
};
